<template>
  <div class="kpt-remote-connectivity-status">
    <div class="columns"  v-if="remote.satelliteNetwork">
      <div class="column">
        <div class="kpt-remote-connectivity-modes" :class="{ 'has-border-grey': !remote.satelliteNetwork, 'has-border-green': remote.satelliteNetwork && remote.satelliteNetwork.online, 'has-border-red': remote.satelliteNetwork && !remote.satelliteNetwork.online }">
          <remote-satellite-signal :strength="remote.satelliteNetwork.snr" v-if="remote.satelliteNetwork.online" />
          <div class="has-text-centered status-centered" v-if="remote.satelliteNetwork">
            <h5>Satellite: {{remote.satelliteNetwork.online ? 'Online' : 'Offline' }}</h5>
            <h3 v-if="remote.satelliteNetwork.online">{{$numeral(remote.satelliteNetwork.snr).format('0.00')}}<span class="is-size-6">dB SNR</span></h3>
            <h6>Beam: {{remote.satelliteNetwork.beam}}</h6>
          </div>
        </div>
      </div>     
    </div>
      <div class="kpt-remote-connectivity-modes has-border-grey" v-else>
        <div class="has-text-centered status-centered"><h5>Satellite Unavailable</h5></div>
      </div>
      <br>
    <div class="cell-network-status">
      <div class="columns" v-if="remote.cellularNetwork">
        <div class="column">
          <div class="kpt-remote-connectivity-modes" :class="{ 'has-border-green': remote.cellularNetwork.online, 'has-border-red': !remote.cellularNetwork.online }">
            <remote-cellular-signal :strength="remote.cellularNetwork.signalStrength" v-if="remote.cellularNetwork.online" />
            <div class="has-text-centered status-centered">
              <h5>Cellular: {{remote.cellularNetwork.online ? 'Online' : 'Offline' }}</h5>
              <h3>{{ remote.cellularNetwork.online ? remote.cellularNetwork.signalStrength + `db` : null }}</h3>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="kpt-remote-connectivity-modes" :class="{ 'has-border-green': remote.cellularNetwork.wiFiEnabled, 'has-border-red': !remote.cellularNetwork.wiFiEnabled }">
            <div class="has-text-centered status-centered">
              <h5>Local WiFi:</h5>
              <h3>{{remote.cellularNetwork.wiFiEnabled ? 'Enabled' : 'Disabled' }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="kpt-remote-connectivity-modes has-border-grey" v-else>
        <div class="has-text-centered status-centered"><h5>Cellular Unavailable</h5></div>
      </div>
    </div>
  </div>
</template>
<script>
import RemoteSatelliteSignal from './RemoteDetailSatelliteSignal.vue';
import RemoteCellularSignal from './RemoteDetailCellularSignal.vue';

export default {
  props: {
    remote: Object
  },
  components: {
    RemoteSatelliteSignal,
    RemoteCellularSignal
  },
}
</script>
<style lang="scss" scoped>
@import '../../styles/colors';

.kpt-remote-connectivity-status {
  .cell-network-status {
    margin-top: -13px;

    .columns {
      margin-top: -25px;
      .column:first-child {
        padding-right: .4rem;
      }
      .column:last-child {
        padding-left: .4rem;
      }
    }
  }

  .kpt-remote-connectivity-modes{
    border: 4px solid $grey-lighter;
    padding: 8px;
    display: flex;
    min-height: 90px;
    align-items: center;

    &.has-border-green {
      border-color: $green;
      background-color: hsl(99, 61%, 95%);
    }
    &.has-border-red {
      border-color: $red;
      background-color: hsl(0, 91%, 95%);
    }
    &.has-border-grey {
      border-color: $grey-lighter;
      background-color: hsl(0, 0%, 95%);
    }

    .status-centered {
      flex: 1 0 auto;
      align-items: center;
    }
  }
}
</style>
